<div>
	<!-- Header row here -->
	@if (detailHeader) {
	<huge-row>
		<mat-col class="pull-left">
			<app-device-details-row-card [data]="detailHeader"></app-device-details-row-card>
		</mat-col>
	</huge-row>
	}

	@if (!loading && detailsObject?.CdrDevice?.IsCapped) {
	<div class="device-disabled-wrapper">
		<div>This device is disabled due to reaching its cap limit</div>
		@if (userHasWriteAccess) {
		<button mat-raised-button (click)="unblockDevice()" color="primary">Enable</button>
		}
	</div>
	}

	<div>
		<div>
			@if (detailsNavOptions) {
			<div class="side-menu-nav">
				<tools-tabbed-nav-list [disabled]="loading" [activePage]="pageChangeVal"
					(selected)="PageChanged($event)" [list]="detailsNavOptions">
				</tools-tabbed-nav-list>
			</div>
			}
		</div>

		<div class="inner-content">
			@if (loading) {
			<div class="mauto text-center">
				<br />
				<br />
				<br />
				<br />
				<mat-spinner class="spinner mauto" name="crescent"></mat-spinner>
				<br />
				<br />
			</div>
			}

			<div>
				@if (!loading && (page == 1 || page == 2)) {
				<div style="margin-top: 1vh;">
					<div style="display: flex;">
						@if (page == 1) {
						<div class="pull-left" size-xs="12">
							@if (detailsObject && deviceDetailsConfig) {
							<tools-device-details-card [data]="deviceDetailsConfig"></tools-device-details-card>
							}
						</div>
						}
						@if (page == 1 && !isKA) {
						<div class="pull-left"
							[style.width]="requestParameters.KaID > 0 || isMikrotik ? '100%' : '75%'">
							<br />
							@if (DailyDataUsageGraphConfig.IsReady) {
							<app-generic-graph-handler #BundleUsageOverTimeGraph [showTools]="false"
								[graphData]="DailyDataUsageGraphConfig" [enableDataLabels]="false"
								[formatXAxisDate]="false"></app-generic-graph-handler>
							}
						</div>
						}
						<div class="pull-left" [style.width]="this.mapDivWidth"
							[hidden]="(page != 1 && page != 2) || (!(requestParameters.KaID > 0) && !isMikrotik)">
							@if (mapCanLoad && detailHeader.TLSEnabled == false) {
							<div>
								@if(deviceLocationsLoading){
								<mat-spinner class="spinner mauto" name="crescent"></mat-spinner>
								}@else{
								@if (deviceLocations) {
								<tools-device-map #deviceMap [detailsObject]="detailsObject"
									(searchChanged)="locationSearched($event)"
									(advancedToggled)="advancedToggled($event)" [locationData]="deviceLocations"
									[isMikrotik]="isMikrotik" [config]="mapConfig">
								</tools-device-map>
								} @else {
								<p class="text-center"> No location history found. </p>
								}
								}
							</div>
							}@else {
							<div>
								@if (DailyDataUsageGraphConfig.IsReady) {
								<app-generic-graph-handler #BundleUsageOverTimeGraph [showTools]="false"
									[graphData]="DailyDataUsageGraphConfig" [enableDataLabels]="false"
									[formatXAxisDate]="false"></app-generic-graph-handler>
								} @else {
								<app-skeleton-loader [height]="12"></app-skeleton-loader>
								}
							</div>
							}
						</div>
					</div>
					@if (page == 1 && isKA) {
					@if (deviceBundleUsed) {
					<div class="pull-left" [style.width]="requestParameters.KaID > 0 || isMikrotik ? '100%' : '75%'">
						<br />
						@if (deviceBundleUsed) {
						<app-device-bundle-used-chart [data]="deviceBundleUsed"></app-device-bundle-used-chart>
						}
					</div>
					}
					}
					@if (page == 2 && (!mapCanLoad || (!(requestParameters.KaID > 0) && !isMikrotik))) {
					<div class="full-width">
						<p class="text-center"> No location history found to load. </p>
					</div>
					}
				</div>
				}

				@if (page == 3) {
				<div>
					<div class="padded-container">
						<div class="split50">
							@if (DailyDataUsageGraphConfig.IsReady) {
							<!-- <app-device-bundle-used-chart [data]="deviceBundleUsed"></app-device-bundle-used-chart> -->
							<app-generic-graph-handler #BundleUsageOverTimeGraph [showTools]="false"
								[graphData]="DailyDataUsageGraphConfig" [enableDataLabels]="false"
								[formatXAxisDate]="false"></app-generic-graph-handler>
							} @else {
							<app-skeleton-loader [height]="12"></app-skeleton-loader>
							}
							<!-- <app-data-bar-chart [total]="6" titleText="Usage past six months"
								[data]="usageOverMonthsData" [applyBoxStyling]="false"
								[customLegendItems]="customLegendItems" [customLegendColors]="customLegendColors"
								[enableRefresher]="true" (selected)="lastSixMonthsPointSelected($event)">
							</app-data-bar-chart> -->
							<app-generic-graph-handler #UsageOverTimeGraph [graphData]="MonthlyDataUsageGraphConfig"
								[showTools]="false" (selected)="lastSixMonthsPointSelected($event)"
								[formatXAxisDate]="false"></app-generic-graph-handler>
						</div>
						@if (this.isCDR && !APNGraphsLoading) {
						<div class="grid">
							@if (VodacomConfig && VodacomConfig.Data.SeriesData?.length > 0) {
							<div style="width: 100%;">
								<app-generic-graph-handler #VodacomGraph [graphData]="VodacomConfig" [showTools]="false"
									[formatXAxisDate]="false"></app-generic-graph-handler>
							</div>
							}

							@if (MTNConfig && MTNConfig.Data.SeriesData?.length > 0) {
							<div style="width: 100%;">
								<app-generic-graph-handler #MTNGraph [graphData]="MTNConfig" [showTools]="false"
									[formatXAxisDate]="false"></app-generic-graph-handler>
							</div>
							}

							@if (TelkomConfig && TelkomConfig.Data.SeriesData?.length > 0) {
							<div style="width: 100%;">
								<app-generic-graph-handler #TelkomGraph [graphData]="TelkomConfig" [showTools]="false"
									[formatXAxisDate]="false"></app-generic-graph-handler>
							</div>
							}
						</div>
						}
					</div>
				</div>
				}

				@if (page == 4) {
				<div>
					<div class="padded-container">
						@if (deviceStatusOverTime) {
						<app-device-status-over-time-chart
							[data]="deviceStatusOverTime"></app-device-status-over-time-chart>
						}
					</div>
				</div>
				}

				@if (page == 5 && detailsObject) {
				<div>
					<!-- Details Tab -->
					<tools-device-full-detail [data]="detailsObject"></tools-device-full-detail>
				</div>
				}

				@if (page == 6 && (isKA || isMikrotik)) {
				<div>
					<div class="padded-container">
						<div style="display: flex; justify-content: space-between;">
							<mat-label>Set device ringfence:</mat-label>
							@if (requestParameters.KaID && requestParameters.KaID > 0) {
							<button mat-button (click)="openLocationRadiusModal()"
								style="background-color: #0f074b; color: white;">SET</button>
							}
						</div>
						@if (!loadingRingfenceData) {
						<tools-device-ring-fence-log [ringFenceData]="ringFenceData">
						</tools-device-ring-fence-log>
						}
						@if (!loadingRingfenceData && ringFenceData == null) {
						<p>No Ringfence logs found. Set one now</p>
						}
						@if (loadingRingfenceData) {
						<mat-spinner class="spinner mauto" name="crescent"></mat-spinner>
						}
					</div>
				</div>
				}

				@if (page == 7 && isMikrotik) {
				<div>
					<app-device-availability-graph [IDs]="requestParameters ? [requestParameters.CdrID] : []">
					</app-device-availability-graph>
				</div>
				}

				@if (page == 8 && isMikrotik) {
				<div>
					<app-device-jitter-graph [IDs]="requestParameters ? [requestParameters.CdrID] : []">
					</app-device-jitter-graph>
				</div>
				}

				@if (page == 9 && isMikrotik) {
				<div>
					<app-device-latency-graph [IDs]="requestParameters ? [requestParameters.CdrID] : []">
					</app-device-latency-graph>
				</div>
				}

				@if (page == 10 && isMikrotik) {
				<div>
					<h1 class="text-center">Available Device Presets</h1>
					@if (presets != null && presets.length > 0) {
					<div class="overflow-scroll">
						<p style="text-align: start;">Start by selecting a preset from the list below:</p>
						<div class="preset-menu" style="display: flex; justify-content: flex-start;">
							@for (preset of presets; track preset) {
							<button mat-button [disabled]="presetLoading" style="color: #ff4081;" id="{{ preset.Name }}"
								type="button" class="nav-button" [ngClass]="{ focus: selectedPreset?.ID == preset.ID }"
								(click)="presetClicked(preset)">{{ preset.Name }}</button>
							}
						</div>
						@if (selectedPreset) {
						<div>
							<div class="content">
								@if (!presetResult) {
								<div class="script-content" [innerHTML]="
										presetToPreview?.length > 0 ? presetToPreview : selectedPreset.Script
									"></div>
								}
								@if (presetResult && selectedPreset) {
								<div class="script-content" [innerHTML]="presetResult"></div>
								}

								@if (!presetResult && selectedPreset.Options?.length > 0) {
								<div>
									<mat-list>
										@for (option of selectedPreset.Options; track option) {
										<mat-list-item>
											<mat-label position="fixed">{{ option.Name }}</mat-label>
											<input matInput [disabled]="presetLoading" [(ngModel)]="option['Value']"
												placeholder="{{ 'Enter the value for ' + option.Name }}" />
										</mat-list-item>
										}
									</mat-list>
								</div>
								}

								@if (presetLoading) {
								<div class="mauto text-center">
									<br />
									<mat-spinner class="spinner mauto" name="crescent"></mat-spinner>
									<br />
								</div>
								}

								<div class="btn-section">
									@if (selectedPreset.Options?.length > 0 && !presetToPreview && selectedPreset) {
									<button mat-button expand="full" (click)="previewPreset()">Preview</button>
									}
									@if (presetToPreview && !presetResult) {
									<button mat-button expand="full" (click)="cancelPresetClick()">Cancel</button>
									}
									@if (
									(presetToPreview || selectedPreset.Options?.length == 0) &&
									!presetResult &&
									isMikrotikAdmin && userHasWriteAccess
									) {
									<button mat-button expand="full" (click)="executePreset()">Execute</button>
									}
									@if (presetResult && selectedPreset) {
									<button mat-button expand="full" (click)="cancelPresetClick()">Finish</button>
									}
								</div>
							</div>
						</div>
						}
					</div>
					}
					@if (presets == null || presets.length == 0) {
					<div class="overflow-scroll">
						<p>There are no presets currently set up for customer use.</p>
					</div>
					}
				</div>
				}

				@if (page == 11) {
				<div>
					<!-- Relay Tab -->
					<mat-chip-set>
						<mat-chip
							(click)="mnoSelected('All', DailyRelayGraphConfig, MonthlyRelayGraphConfig)">All</mat-chip>
						@for (sim of detailsObject.CdrDevice.SIMs; track sim) {
						<mat-chip (click)="mnoSelected(sim.ServiceProvider)">{{ sim.ServiceProvider }}</mat-chip>
						}
					</mat-chip-set>
					@if (mnoAPNs.length > 0) {
					<mat-chip-set>
						@for (val of mnoAPNs; track val) {
						<mat-chip (click)="mnoAPNSelected(val.APN, DailyRelayGraphConfig, MonthlyRelayGraphConfig)"
							selected="val.IP == selectedRelayIP">{{ val.APN }}</mat-chip>
						}
					</mat-chip-set>
					}
					@if (DailyRelayGraphConfig.IsReady) {

					<app-generic-graph-handler [graphData]="DailyRelayGraphConfig" [showTools]="false"
						[formatXAxisDate]="false">
					</app-generic-graph-handler>

					}
					@if (!DailyRelayGraphConfig.IsReady) {
					<app-skeleton-loader [height]="12">
					</app-skeleton-loader>
					}
					@if (MonthlyRelayGraphConfig.IsReady) {

					<app-generic-graph-handler [graphData]="MonthlyRelayGraphConfig" [showTools]="false"
						[formatXAxisDate]="false" (selected)="handleRelayGraphSelection($event, DailyRelayGraphConfig)">
					</app-generic-graph-handler>

					}
					@if (!MonthlyRelayGraphConfig.IsReady) {
					<app-skeleton-loader [height]="12">
					</app-skeleton-loader>
					}
				</div>
				}

				@if (page == 15) {
				<div class="map-display">
					<div class="form-group padded-side-nav">
						<mat-form-field>
							<mat-label>Enter a date range</mat-label>
							<mat-date-range-input [rangePicker]="picker">
								<input matStartDate placeholder="Start date" [formControl]="startDateControl">
								<input matEndDate placeholder="End date" [formControl]="endDateControl">
							</mat-date-range-input>
							<mat-hint>YYYYY/MM/DD – YYYY/MM/DD</mat-hint>
							<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
							<mat-date-range-picker #picker></mat-date-range-picker>
							@if(startDateControl.invalid || endDateControl.invalid) {
							<mat-error>Please enter a valid date range</mat-error>
							}
						</mat-form-field>
					</div>
					@if (simLocations && simLocations.length > 0) {
					<div class="map-container">
						<huge-monorepo-base-map [locations]="simLocations" [calculateCenter]="true"
							[focusedSimTower]="selectedSim"></huge-monorepo-base-map>
					</div>
					} @else if (invalidSimLocationCount == deviceMapFormGroup.get('simHops').value) {
					<div>
						No valid locations to display<br />
						(Latitude: 0 and Longitude: 0)
					</div>
					} @else if (simLocations && simLocations.length == 0) {
					<div>
						No locations to display
					</div>
					} @else {
					<mat-spinner [diameter]="40" class="mauto"></mat-spinner>
					}
				</div>
				<div>
					@if(simLocationsLoading){
					<div class="sim-location-table-container">
						<mat-spinner class="spinner mauto" name="crescent"></mat-spinner>
					</div>
					}@else{
					@for (simLocationData of paginatedLocationsTableData; track simLocationData.simNum; let i =
					$index) {
					<mat-expansion-panel [expanded]="true" class="sim-location-table-container">
						<mat-expansion-panel-header>
							<mat-panel-title>
								Sim {{ i+1 }}: {{simLocationData.data[0].SimNum}}
							</mat-panel-title>
							<mat-panel-description>
								SimCell: {{simLocationData.data[0].SimCell}}
							</mat-panel-description>
						</mat-expansion-panel-header>
						<app-card-table [tableHeaders]="deviceLocationsTableHeaders" [data]="simLocationData.data"
							[uniqueID]="i" [currentPage]="simLocationData.page" [enableTablePagination]="true"
							(paginateEvent)="getPagedDevices($event,simLocationData)"
							[options]="deviceLocationTableOptions" [totalItems]="simLocationData.totalLength"
							[breakpoint]="ScreenSize.TABLET" [originalStyling]="false"
							(rowSelectedEvent)="updateFocussedTower({longitude: simLocationData.data[0].Long, latitude: simLocationData.data[0].Lat})">
						</app-card-table>
					</mat-expansion-panel>
					}
					}
				</div>
				}
			</div>
		</div>
	</div>
</div>

@if (showChatModal && requestParameters) {
<div>
	<app-chat-popup [request]="requestParameters" (closeChatModalEvent)="closeChatModal()">
	</app-chat-popup>
</div>
}

@if (!showChatModal) {
<button mat-fab class="chat-button">
	<button mat-fab (click)="showChat()">
		<mat-icon><img src="assets/icon/chat.svg" /></mat-icon>
	</button>
</button>
}